<ng-container *ngIf="title; else noTitleTpl">
  <app-card
    [cardBodyClasses]="'pt-0'"
    [cardClasses]="'my-7'"
    [cardHeaderClasses]="'pb-0'"
    [header]="true"
  >
    <ng-container cardHeader>
      <div class="fw-bold font-16">{{ title }}</div>
    </ng-container>
    <div cardBody>
      <ng-container
        *ngIf="
          baseDatasourceLog.isTableLoaded && baseDatasourceLog.totalItem$.getValue() === 0;
          else stepsTpl
        "
      >
        <div class="d-flex justify-content-center align-items-center flex-column py-10">
          <span class="svg-icon svg-icon-empty mb-10" [inlineSVG]="iconNone"></span>
          <p class="fs-5 mb-0 text-description text-gray-400">{{ config.emptyStateText }}</p>
        </div>
      </ng-container>
    </div>
  </app-card>
</ng-container>

<!-- Consumer gak nge-set [title] — pertahanin markup PERSIS kayak sebelumnya (0 behavior change). -->
<ng-template #noTitleTpl>
  <ng-container
    *ngIf="
      baseDatasourceLog.isTableLoaded && baseDatasourceLog.totalItem$.getValue() === 0;
      else elseBlock
    "
    cardBody
  >
    <app-card-empty [text]="config.emptyStateText" [icon]="iconNone"></app-card-empty>
  </ng-container>

  <ng-template #elseBlock>
    <app-card>
      <div cardBody>
        <ng-container *ngTemplateOutlet="stepsTpl"></ng-container>
      </div>
    </app-card>
  </ng-template>
</ng-template>

<ng-template #stepsTpl>
  <ng-container *ngFor="let record of processedDataLog; let first = first; let last = last">
    <div [class.last]="last" [class.latest]="first" class="step">
      <div class="min-w-150px align-self-start">
        <span class="date">{{
          utilities.timeStampToDate(record['submission_date'], 'dd-MM-yyyy HH:mm:ss')
        }}</span>
      </div>

      <div
        *ngIf="baseDatasourceLog.isFinishLoadingSubject.value; else loadingStepper"
        class="v-stepper"
      >
        <div class="circle"></div>
        <div class="line"></div>
      </div>

      <ng-template #loadingStepper>
        <app-table-content></app-table-content>
      </ng-template>

      <div class="content row">
        <div class="container">
          <div class="row">
            <div class="col align-self-start">
              <span class="title">{{ record['title'] }}</span>
              <ng-container
                [ngTemplateOutletContext]="{ data: record }"
                [ngTemplateOutlet]="record._link ? descriptionWithLink : defaultDescription"
              ></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- end loop data from variable list -->

  <ng-template #descriptionWithLink let-data="data">
    <span class="desc d-flex">
      <span class="me-2">{{ data.desc }}</span>
      <ng-container *ngIf="data._link">
        <ng-container *ngIf="data._link.queryParams; else defaultLink">
          <a
            (click)="navigateToDetail(data._link)"
            class="text-info cursor-pointer fw-bold text-decoration-underline"
          >
            {{ data._link.label }}
          </a>
        </ng-container>
        <ng-template #defaultLink>
          <span
            [routerLink]="data._link.url"
            class="text-info cursor-pointer fw-bold text-decoration-underline"
            >{{ data._link.label }}</span
          >
        </ng-template>
      </ng-container>
    </span>
  </ng-template>

  <ng-template #defaultDescription let-data="data">
    <span class="desc d-flex">{{ data.desc }}</span>
    <ng-container *ngIf="data._reasonText">
      <span class="desc-reason">Alasan Penolakan: {{ data._reasonText }}</span>
    </ng-container>
  </ng-template>

  <div class="d-flex justify-content-between py-4">
    <app-mai-material-bottom-table
      (changePage)="changePageEvent($event)"
      [baseDataTableComponent]="baseDatasourceLog"
      [isFinishLoadingSubject]="baseDatasourceLog.isFinishLoadingSubject"
      class="w-100"
    ></app-mai-material-bottom-table>
  </div>
</ng-template>
